export enum ContentfulContentType {
  species = 'speciesPage',
}

export enum ContentfulEntries {
  AboutThisApp = '3q3nGi5YUVfSxpV68WjFyW',
  SpeciesIdInfo = '62hc8Nf3t6y9m9LJeUiaBK',
  SpeciesSummary = '7CAZ1DCg2LKzk9HRcklfx4',
  IdsContent = '305aZCX9akkurKLoRba9Y6',
  DetailsContent = '5R6MAe47ZVscezNiMpS2vS',
  HandlingContent = 'f8X3spDrFQ0SBlYyT75Q0',
}
